import React from 'react';
import { Navigate } from 'react-router-dom';

const Offers = () => {
    
    return <Navigate to="/offers/bank-offers" />;
};

export default Offers;
